<div style="color: var(--my-toolbox-form-error)">
  <sl-icon name="info-circle"></sl-icon>
</div>
<p>
  <ng-content></ng-content>
</p>
